import { CartTicket } from '@Interfaces/interfaces';
import { AuthService } from '@Services/auth.service';
import { LanguageService } from '@Services/language.service';
import { MuseumService } from '@Services/museum.service';
import { UserService } from '@Services/user.service';
import { addTicketToCart, clearCart, removeTicketFromCart } from '@State/Actions/cart.actions';
import { clearSingleMuseum, clearVisitList, loadMuseumsByPage, loadSingleMuseum, loadSingleMuseumVisitList } from '@State/Actions/museum.actions';
import { clearUserInfo, loadAllUserInfo } from '@State/Actions/user.actions';
import { AppState } from '@State/app.state';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.scss'],
    standalone: false
})
export class TestComponent implements OnInit {

  public date:string = new Date().toISOString();
  // public tickets$!: Observable<CartTicket[]>;
  // public cartTotal$!: Observable<number>;

  constructor(
    private languageService: LanguageService,
    private router: Router,
    private museumService: MuseumService,
    private userService: UserService,
    private store:Store<AppState>,
    private authSvc:AuthService
  ) {}

  ngOnInit(): void {
    // this.testLoadUserInfo()
    // this.testGetAllMuseums()
    // this.testGetSingleMuseum();
    // this.testLoadVisitList();
    // this.tickets$ = this.store.select(state => state.cart.tickets);
    // this.cartTotal$ = this.store.select(state => state.cart.total);
    // this.testDotDotDotApiRedux()
  }

  public testLogin(){
    this.authSvc.login();
  }

  public testDotDotDotApiRedux(){
    this.store.dispatch(loadMuseumsByPage({ page:1, pageSize:10 }))
  }

  public testAddTicket1(){
    // let ticket1:CartTicket = {
    //   idoff:"1",
    //   idRoute:1,
    //   idFascia:1,
    //   idMuseum:137,
    //   counter:2,
    //   date: this.date,
    //   day: "27/11/2023",
    //   hour:'09:00-21:00',
    //   museumDen:"TEST",
    //   prezzo:10.00,
    //   tickettype:"TEST tkt"
    // }

    // this.store.dispatch(addTicketToCart({ ticket: ticket1 }))
  }
  public testAddTicket2(){
    // let ticket2:CartTicket = {
    //   idoff:"2",
    //   idRoute:2,
    //   idFascia:2,
    //   idMuseum:137,
    //   counter:5,
    //   date: this.date,
    //   day: "27/11/2023",
    //   hour:'09:00-21:00',
    //   museumDen:"TEST",
    //   prezzo:10.00,
    //   tickettype:"TEST tkt"
    // }

    // this.store.dispatch(addTicketToCart({ ticket: ticket2 }))
  }

  public testRemoveTicket(ticket:CartTicket){
    this.store.dispatch(removeTicketFromCart({ ticket:ticket }))
  }

  public testClearCart(){
    this.store.dispatch(clearCart())
  }

  public testGetSingleMuseum(){
    this.store.dispatch(loadSingleMuseum({codesr:'33f77159-0acd-40c4-8524-701f33aae108'}))
  }

  public testClearSingleMuseum(){
    this.store.dispatch(clearSingleMuseum())
  }

  public testLoadVisitList(){
    // this.store.dispatch(loadSingleMuseumVisitList({codesr:"33f77159-0acd-40c4-8524-701f33aae108", lang: null })
  }

  public testClearVisitList(){
    this.store.dispatch(clearVisitList())
  }

  public testLoadUserInfo(){
    this.store.dispatch(loadAllUserInfo())
  }

  public clearUserInfoState(){
    this.store.dispatch(clearUserInfo());
  }

  public testNavigation(codesr:string) {
    this.router.navigate([`/buyTicketless/${codesr}`]);
  }
}
